/*
    Create by fanglijuan 2017-05-26
*/
'use strict';
angular.module("deleteAccountSynchroToPersonalModule", [])
    .controller("deleteAccountSynchroToPersonalCtrl", ["$scope", "$location", "$stateParams", "$q", "$filter", "$timeout", "$modalInstance", "trsHttpService", 'treeService', "$state", "$validation", "item", "whichTabShow", "trsspliceString", "globleParamsSet", "modalDialog", "accountSynchroToPersonalService",'nameChange',
        function($scope, $location, $stateParams, $q, $filter, $timeout, $modalInstance, trsHttpService, treeService, $state, $validation, item, whichTabShow, trsspliceString, globleParamsSet, modalDialog, accountSynchroToPersonalService,nameChange) {
            initStatus();
            initData();

            function initStatus() {
                $scope.status = {
                    SynUserId: item.SYNUSERID, //用户id
                    whichTabShow: whichTabShow,
                    UserName: item.USERPINYIN, //用户名称
                };
                $scope.data = {
                    globalName:nameChange.globalName,
                    modalTitle: "删除",
                    groupPaths: [],
                    groupPath: "", //页面显示的8531组织路径
                    MLFgroupPath: "", //页面显示的MLF组织路径
                    currUser: {

                    },
                    currMLFUser: {

                    },
                };
            }
            /**
             * [initData description]初始化数据
             */
            function initData() {
                //根据用户ID获取需要同步的用户信息
                getSynUserDetail();

            }
            //根据用户ID获取需要同步的用户信息
            function getSynUserDetail() {
                var params = {
                    "serviceid": "mlf_usermanagement",
                    "methodname": "getSynUserDetail",
                    "SynUserId": $scope.status.SynUserId
                };
                trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, "get").then(function(data) {
                    $scope.data.currUser = data[0].SYNUSER; //8531用户信息
                    $scope.data.groupPath = data[0].GROUPPATH; //8531组织路径

                    $scope.data.currMLFUser = data[1].USER[0];
                    if (data[1].GROUP.length > 0) {
                        getGroupPaths(trsspliceString.spliceString(data[1].GROUP, "GROUPID", ","), "/");
                    }
                });
            }
            //根据用户ID获取MLF的用户信息
            function queryMLFUserById() {
                var params = {
                    "serviceid": "mlf_usermanagement",
                    "methodname": "getUserDetail",
                    "UserName": $scope.status.UserName
                };
                trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, "get").then(function(data) {
                    $scope.data.currMLFUser = data.USER[0];
                    $scope.data.selectedRole = data.ROLEDATA;
                    if (data.GROUP.length > 0) {
                        getGroupPaths(trsspliceString.spliceString(data.GROUP, "GROUPID", ","), "/");
                    }
                    if (data.ROLEDATA.length > 0) {
                        $scope.data.oldRoleIds = trsspliceString.spliceString(angular.copy(data.ROLEDATA), "ROLEID", ",");
                    }
                });
            }
            //根据组织IDS获取组织路径
            function getGroupPaths(groupIds, dcim) {
                var params = {
                    "serviceid": "mlf_group",
                    "methodname": "getGroupPaths",
                    "GroupIds": groupIds,
                    "dcim": dcim
                };
                trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, "get").then(function(data) {
                    $scope.data.groupPaths = data;
                    $scope.data.oldGroupPaths = angular.copy($scope.data.groupPaths);
                });
            }
            //删除：点击确定
            $scope.delete = function() {
                var params = {
                    serviceid: "mlf_usermanagement",
                    methodname: "deleteSynUser",
                    SynUserId: item.SYNUSERID,
                    UserName: $scope.status.UserName,
                };
                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, "get").then(function(data) {
                    /*modalDialog.alertType("删除成功", "", "success", false, function() {
                        $modalInstance.close();
                    });*/
                    var res = data.ISSUCCESS == 'true' ? 'success' : 'error';
                    modalDialog.alertType(data.REPORTS[0].DETAIL, "", res, false, function() {
                        $modalInstance.close();
                    });
                });
            };

            //取消
            $scope.cancel = function() {
                $modalInstance.dismiss();
            };
        }
    ]);
